import styled from "styled-components";

export const Section = styled.section`
  padding: ${({ theme, $py }) => $py || theme.spacing["4xl"]} 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme, $py }) => $py || theme.spacing["2xl"]} 0;
  }
  background: ${({ $bg, theme }) => {
    if ($bg === "navy") return theme.colors.navy;
    if ($bg === "pearl") return theme.colors.pearl;
    if ($bg === "offWhite") return theme.colors.offWhite;
    return $bg || "transparent";
  }};
  color: ${({ $bg, theme }) =>
    $bg === "navy" ? theme.colors.white : theme.colors.textPrimary};
`;

export const Container = styled.div`
  max-width: ${({ $wide }) => ($wide ? "1440px" : "1280px")};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing["2xl"]};

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 ${({ theme }) => theme.spacing.xl};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 ${({ theme }) => theme.spacing.lg};
  }
`;

export const SectionEyebrow = styled.p`
  font-family: ${({ theme }) => theme.fonts.caps};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacings.widest};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const SectionTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: clamp(2rem, 4vw, ${({ theme }) => theme.fontSizes["5xl"]});
  font-weight: ${({ theme }) => theme.fontWeights.light};
  line-height: ${({ theme }) => theme.lineHeights.tight};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const SectionSubtitle = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ $light }) => ($light ? "rgba(255,255,255,0.6)" : "inherit")};
  color: ${({ $light, theme }) =>
    $light ? "rgba(255,255,255,0.6)" : theme.colors.textSecondary};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
  max-width: 560px;
`;
